var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
/**
 * @module Viewer
 * @class HtmlController
 * 
 */
OCS.Viewer.Classes.HtmlController = new Class({
    Implements: [Options, Events],
    events: {},
    options: {
        map_bg_color: '#E3E2E2',
        panel_container_prefix: 'panel_',
        event_namespace: '.controller',
        animation_slider_max: 1,
        animation_slider_min: 0,
        animation_slider_step: 0.01
    },
    map_controller: null,
    container: null,
    templates: {},
    bound_methods: {},
    alert_box: null,
    map_controls: null,
    legend_container: null,
    initialize: function (element, ops) {
        var obj = element.retrieve('viewer_html');
        if (obj) {
            return obj;
        }

        this.setOptions(ops);
        this.container = element;
        this.bound_methods.load_html_completed = this.load_html_completed.bind(this);
        this.bound_methods.handle_mouse_down = this.handle_mouse_down.bind(this);
        this.bound_methods.handle_mouse_up = this.handle_mouse_up.bind(this);
        this.bound_methods.handle_key_down = this.handle_key_down.bind(this);
        this.bound_methods.handle_key_up = this.handle_key_up.bind(this);
        this.bound_methods.process_alert_box = this.process_alert_box.bind(this);
        this.bound_methods.process_map_controls = this.process_map_controls.bind(this);
        this.bound_methods.handle_user_preference_update = this.handle_user_preference_update.bind(this);
        this.bound_methods.load_alert_box = this.load_alert_box.bind(this);

        this.bound_methods.toggle_play_button = this.toggle_play_button.bind(this);
        this.bound_methods.toggle_pause_button = this.toggle_pause_button.bind(this);


        this.bound_methods.on_click_alert_box_close = this.on_click_alert_box_close.bind(this);
        this.bound_methods.on_slider_speed_change = this.on_slider_speed_change.bind(this);
        this.bound_methods.on_slider_scrubber_change = this.on_slider_scrubber_change.bind(this);
        this.bound_methods.on_slider_scrubber_mousedown = this.on_slider_scrubber_mousedown.bind(this);
        this.register_unique_dom_event({event_name: this.options.update_user_preference_string, specific_event: true, callback: this.bound_methods.handle_user_preference_update});
        element.store('viewer_html', this);
    },
    init: function () {
        // Tie into the proper events
        var map_datetime = this.get_map_controller().get_map_datetime();
        map_datetime.addEvent('animation_started', this.bound_methods.toggle_play_button);
        map_datetime.addEvent('animation_stopped', this.bound_methods.toggle_pause_button);
        this.init_templates();
        OCS.Bootstrap.process_content_interactive_viewer(this.container);

    },
    /*
     * 
     * Event Handlers
     * 
     */
    handle_sprite_loop: function (target, e) {
        target.removeClass('sprite-loop').addClass('sprite-rocker');
        this.get_map_controller().get_map_datetime().set_animation_type('rock');
    },
    handle_sprite_panel_options_button: function (target, e) {
        target.siblings('.panel_options_container').show().addClass('active').addClass('panel_options-in-animation');
        target.hide();
    },
    handle_sprite_rocker: function (target, e) {
        target.removeClass('sprite-rocker').addClass('sprite-loop');
        var map_cont = this.get_map_controller();
        var map_datetime = map_cont.get_map_datetime();
        map_datetime.set_animation_direction(1);
        map_datetime.set_animation_type('loop');
    },
    handle_mouse_down: function (event) {
        var map_cont = this.get_map_controller();
        var map_datetime = map_cont.get_map_datetime();


        var target = event.target;
        if (!target.hasClass('slider')) {
            //e.stopImmediatePropagation();
        }
        if (target.hasClass('sprite-reverse')) {
            map_datetime.start_animation(map_datetime.on_go_to_previous_frame.bind(map_datetime));
        } else if (target.hasClass('sprite-forward')) {
            map_datetime.start_animation(map_datetime.on_go_to_next_frame.bind(map_datetime));
        }
    },
    handle_mouse_up: function (event) {
        var map_cont = this.get_map_controller();
        var map_datetime = map_cont.get_map_datetime();


        var target = event.target;
        if (!target.hasClass('slider')) {
            //e.stopImmediatePropagation();
        }
        if (target.hasClass('sprite-back')) {
            map_datetime.on_go_to_first_frame();
        } else if (target.hasClass('sprite-play')) {
            map_datetime.on_play();
        } else if (target.hasClass('sprite-pause')) {
            map_datetime.on_pause();
        } else if (target.hasClass('sprite-next')) {
            map_datetime.on_go_to_last_frame();
        } else if (target.hasClass('sprite-rocker')) {
            this.handle_sprite_rocker(target, event);
        } else if (target.hasClass('sprite-loop')) {
            this.handle_sprite_loop(target, event);
        } else if (target.hasClass('remove-product')) {
            map_cont.controller_event('remove_product', {target: target, e: event});
        } else if (target.hasClass('fullscreen-product')) {
            map_cont.controller_event('fullscreen_product', {target: target, e: event});
        } else if (target.hasClass('add-to-my-products')) {
            map_cont.controller_event('add_to_my_products', {target: target, e: event});
        } else if (target.hasClass('sprite-reverse')) {
            map_datetime.stop_animation();
        } else if (target.hasClass('sprite-forward')) {
            map_datetime.stop_animation();
        } else if (target.hasClass('slider-speed')) {

        } else {
            // This is a mouse up event on something we are not familiar with or on the forward or reverse buttons
            //map_datetime.stop_animation();
        }
    },
    handle_key_down: function (event) {
        if (event.code === 32) { // 32 ==> space
            this.handle_mouse_down(event);
        }
    },
    handle_key_up: function (event) {
        if (event.code === 32) { // 32 ==> space
            this.handle_mouse_up(event);
        }
    },
    handle_user_preference_update: function (value, e) {

    },

    on_layer_visibility_click: function (data, e) {
        var controller = this.get_map_controller();
        var group_id = jQuery(e.currentTarget).parent().data('group_id');
        controller.map_event(OCS.Viewer.Config.events.TOGGLE_LAYER_VISIBILITY, {id: group_id});
    },
    on_layer_legend_visibility_click: function (data, e) {
        var controller = this.get_map_controller();
        var group_id = jQuery(e.currentTarget).parent().data('group_id');
        controller.map_event(OCS.Viewer.Config.events.TOGGLE_LAYER_LEGEND_VISIBILITY, {id: group_id});
    },
    on_click_alert_box_close: function (event) {
        if (event) {
            event.stop();
        }
        if (this.alert_box) {
            this.alert_box.getElements('.sprite_delete').each(function (delete_button_el) {
                delete_button_el.removeEvent('click', this.bound_methods.on_click_alert_box_close);
            }.bind(this));
            var tween = this.alert_box.get('tween');
            if (tween && tween.length) {
                tween[0].start('height', 0).then(function () {
                    this.alert_box.destroy();
                    this.alert_box = null;
                }.bind(this));
            }

        }
    },

    on_slider_speed_change: function (event) {
        this.update_slider_bg(event.target);
        var map_cont = this.get_map_controller();
        var map_datetime = map_cont.get_map_datetime();
        var was_animating = map_datetime.is_animating();
        if (was_animating) {
            map_datetime.stop_animation();
        }
        var speed = this.get_animation_speed_from_slider_value(event.target.get('value').toFloat());
        map_datetime.set_animation_speed(speed);
        if (was_animating) {
            // Resume the animation with the new speed
            map_datetime.start_animation();
        }
    },
    on_slider_scrubber_change: function (event) {
        this.update_slider_bg(event.target);
        this.get_map_controller().get_map_datetime().on_go_to_frame({current: (event.target.get('value')).toInt()});
    },
    on_slider_scrubber_mousedown: function (event) {
        this.get_map_controller().get_map_datetime().stop_animation();
    },
    /*
     * Actions
     */
    apply_map_listeners: function () {
        var container = this.container;
        container.addEvent('mousedown', this.bound_methods.handle_mouse_down);
        container.addEvent('mouseup', this.bound_methods.handle_mouse_up);
        container.addEvent('keydown', this.bound_methods.handle_key_down);
        container.addEvent('keyup', this.bound_methods.handle_key_up);
        container.addEvent(OCS.Viewer.Config.events.PRODUCT_DOWN, this.bound_methods.load_alert_box);


    },
    unapply_map_listeners: function () {
        var container = this.container;
        container.removeEvent('mousedown', this.bound_methods.handle_mouse_down);
        container.removeEvent('mouseup', this.bound_methods.handle_mouse_up);
        container.removeEvent('keydown', this.bound_methods.handle_key_down);
        container.removeEvent('keyup', this.bound_methods.handle_key_up);
        container.removeEvent(OCS.Viewer.Config.events.PRODUCT_DOWN, this.bound_methods.load_alert_box);
    },
    frame_changed: function (layer_groups, map_datetime) {
        var ts = map_datetime.get_current_epoch_time();
        var end = map_datetime.get_end_epoch_time();
        var start = map_datetime.get_start_epoch_time();

        if(this.map_controls) {
            var slider_scrubber = this.map_controls.getElement('input.slider_scrubber');
            if(slider_scrubber) {
                slider_scrubber.set('min', start+60000);
                slider_scrubber.set('max', end);
                slider_scrubber.set('value', ts);
            }
        }

        var element;
        Object.each(layer_groups, function (layer_group, idx) {
            var layerTime;
            if (layer_group.get_active_timestamp_epoch) {
                layerTime = moment(layer_group.get_active_timestamp_epoch());
            } else if (layer_group.get_map_datetime_obj) {
                var map_obj = layer_group.get_map_datetime_obj();
                layerTime = moment(map_obj.get_current_epoch_time());
            } else {
                layerTime = moment(ts);
            }
            var mapTime = moment(ts);
            var relTime = (layerTime.isValid() && mapTime.isValid()) ? layerTime.from(mapTime) : '--';
            relTime = (relTime.indexOf('in') === 0) ? '-0m' : relTime;

            element = this.container.getElement('div.layer_' + idx+" .time-ago");
            if(element) {
                element.set('html', relTime);
            }
        }.bind(this));

        element = this.container.getElement('span.start_ts_label');
        var start_ts = moment(start);
        var end_ts = moment(end);
        if(element) {
            element.set('html', start_ts.from(end_ts).replace('-', ''));
        }


    },
    init_alert_box: function () {
        this.templates.alert_box.addEvent('success', this.bound_methods.process_alert_box);
    },

    init_panel_options_controls: function (html) {
        var container = this.container;
        var existing_panel_options = jQuery('.panel_options_container', container);
        if (existing_panel_options.length) {
            existing_panel_options.remove();
        }
        var existing_panel_button = jQuery('.panel_options_arrow', container);
        if (existing_panel_button.length) {
            existing_panel_button.remove();
        }

        var context = jQuery(container);
        context.append(html);
        var map_height = jQuery(container).outerHeight(),
                map_options_height = jQuery('.title', container).outerHeight(),
                map_controls_container_height = 52,
                legend_info_container_height = 20,
                legend_container_height = 10,
                offset = 15;
        var options_max_height = map_height - map_options_height - map_controls_container_height - legend_info_container_height - legend_container_height - offset;
        context.find('.panel_options_container > .options').css('max-height', options_max_height + 'px');
        this.init_panel_options_controls_events();

    },
    init_panel_options_controls_events: function () {
        var context = jQuery(this.container);
        this.register_unique_dom_event({event_name: 'click', callback: this.on_layer_visibility_click.bind(this), fire_immediately: true, specific_event: true, selector: '.layer-visibility', context: context}, 'layer_visibility');
        this.register_unique_dom_event({event_name: 'click', callback: this.on_layer_legend_visibility_click.bind(this), fire_immediately: true, specific_event: true, selector: '.legend', context: context}, 'legend_visibility');
    },
    init_radar_console_controls: function (html, template_request) {
        var container = this.container;
        var context = jQuery(container);
        var args = template_request.get_other_args();
        context.addClass('radar').append(html);


        var item = jQuery('.radar-options .' + args.product.product.toLowerCase(), context);
        if (item) {
            item.addClass('active');
            item.siblings('.product-name').addClass('active');
        }
        this.init_radar_console_controls_events();

    },
    init_radar_console_controls_events: function () {
        var container = this.container;
        var context = jQuery(container);
        var title_bar_height = 26;
        var animation_bar_height = 42;
        var container_height = context.height();
        var toggle_site_dropdown = function (target) {
            jQuery('.site-options', context).slideToggle(200);
            target.toggleClass('active');
        };
        var close_site_dropdown = function (target) {
            if (jQuery('.site-options', context).is(':visible')) {
                jQuery('.site-options', context).slideUp(200);
                jQuery('.site-info', context).removeClass('active');
            }
        };
        var toggle_radar_dropdown = function (target) {
            jQuery('.radar-options', context).slideToggle(200);
            target.toggleClass('active');
        };
        var close_radar_dropdown = function (target) {
            if (jQuery('.radar-options', context).is(':visible')) {
                jQuery('.radar-options', context).slideToggle(200);
                jQuery('.product-info', context).removeClass('active');
            }
        };

        jQuery('.radar_console_container', context).on('click', function (e) {
            var controller = this.get_map_controller();
            e.preventDefault();
            var container_height_offset = container_height - title_bar_height - animation_bar_height - 50;
            jQuery('.radar-options', context).css('max-height', container_height_offset + 'px').css('overflow', 'auto');
            jQuery('.site-options', context).css('max-height', container_height_offset + 'px').css('overflow', 'auto');

            var target = jQuery(e.target, context);
            if (target.hasClass('product-info')) {
                close_site_dropdown(target);
                toggle_radar_dropdown(target);
            }
            if (target.hasClass('site-info')) {
                close_radar_dropdown(target);
                toggle_site_dropdown(target);
            }
            if (target.hasClass('clickable')) {
                this.change_radar_product(target);
                var product = target.attr('rel');
                product = product.toUpperCase();
                controller.on_change_radar_product(product);
            }
            if (target.hasClass('radar-site')) {
                this.change_radar_site(target);
                var site = target.attr('rel');
                site = site.toUpperCase();
                controller.on_change_radar_site(site);
                close_site_dropdown(target);
            }
        }.bind(this));
    },

    init_templates: function () {
        this.templates.advisory_info = new OCS.Viewer.Classes.HtmlTemplateRequest({template_name: 'advisory_info', url: OCS.Package.root + 'html/advisory_info.html'});
        this.templates.user_layer_popup = new OCS.Viewer.Classes.HtmlTemplateRequest({template_name: 'user_layer_popup', url: OCS.Package.root + 'html/user_layer_popup.html'});
        this.templates.alert_box = new OCS.Viewer.Classes.HtmlTemplateRequest({template_name: 'alert_box', url: OCS.Package.root + 'html/alert_box.html'});
        this.templates.map_controls = new OCS.Viewer.Classes.HtmlTemplateRequest({template_name: 'map_controls', url: OCS.Package.root + 'html/map_controls.html'});
        this.templates.map_controls.addEvent('success', this.bound_methods.process_map_controls);
        this.templates.radar_console = new OCS.Viewer.Classes.HtmlTemplateRequest({template_name: 'radar_console', url: OCS.Package.root + 'html/radar_console.html'});
        this.templates.radar_console.addEvent('success', this.init_radar_console_controls.bind(this));
    },

    /*
     * 
     * @param {type} type - The template name to retrieve
     * @param {type} html_attributes - Attributes to fill into the template
     * @param {type} obj - A class containing the set_html method.
     * @returns {undefined}
     */
    load_html: function (type, html_attributes, obj) {
        if (this.templates[type]) {
            this.templates[type].add_on_success_obj(obj);
            this.templates[type].addEvent('completed', this.bound_methods.load_html_completed);
            this.templates[type].get_html(html_attributes);
        }
    },
    load_html_completed: function (template_request) {
        template_request.removeEvent('completed', this.bound_methods.load_html_completed);
        // Reinit the system with the new html applied
        OCS.Bootstrap.process_content_interactive_viewer(this.container);
    },
    load_alert_box: function (message) {
        if (message) {
            this.templates.alert_box.get_html({message: message});
        }
    },
    process_alert_box: function (html) {
        if (this.alert_box) {
            this.alert_box.destroy();
        }
        this.alert_box = Elements.from(html).inject(this.container);
        this.alert_box.getElements('.sprite_delete').each(function (delete_button_el) {
            delete_button_el.addEvent('click', this.bound_methods.on_click_alert_box_close);
        }.bind(this));
        this.alert_box.set('tween', {duration: 250, transition: 'bounce:out', link: 'ignore'});

    },
    process_map_controls: function (html) {
        if (this.map_controls) {
            this.map_controls.destroy();
        }
        var map_el = Elements.from(html).inject(this.container);
        this.map_controls = map_el[0];
        var speed_slider = this.map_controls.getElement('input.slider_speed');
        if (speed_slider) {
            speed_slider.addEvents({
                'input': this.bound_methods.on_slider_speed_change,
                'change': this.bound_methods.on_slider_speed_change,
            });
        }
        var slider_scrubber = this.map_controls.getElement('input.slider_scrubber');
        if (slider_scrubber) {
            slider_scrubber.addEvents({
            'input': this.bound_methods.on_slider_scrubber_change,
            'change': this.bound_methods.on_slider_scrubber_change,
            'mousedown': this.bound_methods.on_slider_scrubber_mousedown
            });
        }        
        var lc = this.map_controls.getElement('div.legend_container');
        if (lc) {
            this.legend_container = new OCS.Viewer.Classes.LegendContainer(lc);
            this.fireEvent('legend_container_created', this);
        }

    },
    load_map_controls: function () {
        var map_controller = this.get_map_controller();
        var map_datetime = map_controller.get_map_datetime();
        var animation_control_ops = {};
        animation_control_ops.start_ts = map_datetime.get_start_epoch_time();
        animation_control_ops.end_ts = map_datetime.get_end_epoch_time();
        var start_ts = moment(animation_control_ops.start_ts),
                end_ts = moment(animation_control_ops.end_ts);
        animation_control_ops.start_label = start_ts.from(end_ts).replace('-', '');
        animation_control_ops.end_label = 'Now';

        animation_control_ops.animation_slider_max = this.options.animation_slider_max;
        animation_control_ops.animation_slider_min = this.options.animation_slider_min;
        animation_control_ops.animation_slider_step = this.options.animation_slider_step;

        animation_control_ops.animation_slider_value = this.get_animation_slider_value_from_speed(map_datetime.get_animation_speed());
        this.templates.map_controls.get_html(animation_control_ops);
    },

    load_radar_console: function (site, product, options) {
        this.templates.radar_console.set_other_args({site: site, product: product});
        this.templates.radar_console.get_html(options);
    },
    register_unique_dom_event: function (event_ops, storage_name) {
        var event_manager = OCS.Viewer.Functions.get_event_manager();
        if (!storage_name) {
            storage_name = event_ops.event_name;
        }
        if (this.events.hasOwnProperty(storage_name) && this.events[storage_name]) {
            event_manager.unsubscribe(this.events[storage_name]);
        }
        this.events[storage_name] = event_manager.subscribe(event_ops);
    },
    remove_event_listeners: function () {
        var event_manager = OCS.Viewer.Functions.get_event_manager();
        Object.each(this.events, function (event_key) {
            event_manager.unsubscribe(event_key);
        }.bind(this));
    },
    toggle_play_button: function (e) {
        var playBtn = jQuery('.play-btn', jQuery(this.container));
        if (playBtn.hasClass('sprite-play')) {
            playBtn.removeClass('sprite-play').addClass('sprite-pause');
        }
    },
    toggle_pause_button: function (e) {
        var playBtn = jQuery('.play-btn', jQuery(this.container));
        if (!playBtn.hasClass('sprite-play')) {
            playBtn.removeClass('sprite-pause').addClass('sprite-play');
        }
    },
    update_countainer_bg_color: function () {
        var $container = jQuery(this.container);
        $container.css('background', this.options.map_bg_color);
    },
    update_map_controls_legend: function (tooltip_text, status, frac) {
        if (this.legend_container) {
            this.legend_container.update(tooltip_text, status, frac);
        }
    },
    update_radar_site: function (site_name) {
        var context = jQuery(this.container);
        this.change_radar_site(jQuery('.site-options .' + site_name, context));
    },
    update_radar_product: function (product_name) {
        var context = jQuery(this.container);
        this.change_radar_product(jQuery('.radar-options .' + product_name.toLowerCase() + ' span', context));
    },
    change_radar_site: function (target) {
        var context = jQuery(this.container);
        target.siblings().removeClass('active');
        target.addClass('active');
        jQuery('.site-info', context).html(target.text());
    },
    change_radar_product: function (target) {
        var context = jQuery(this.container);
        jQuery('.rdr-btn', context).not('.nomutex').removeClass('active');
        jQuery('.product-name', context).removeClass('active');
        target.parent().addClass('active');
        target.parent().siblings('.product-name').addClass('active');
        if (target.data('product-display-name')) {
            jQuery('.product-info', context).html(target.data('product-display-name'));
        } else {
            jQuery('.product-info', context).html(target.data('product'));
        }
    },
    update_slider_bg: function (target) {
        var min = target.get('min');
        var max = target.get('max');
        var value = target.get('value');

        var val = (value - min) / (max - min);
        if (document.html.hasClass('msie')) {
            // IE uses the ::-ms-fill-lower and ::-ms-fill-upper pseudos, so we don't need
            // to handle this in code
        } else if (!document.html.hasClass('msie')) {
            target.setStyle('background-image', '-moz-gradient(linear, left top, right top, ' + 'color-stop(' + val + ', #4eb7cd), ' + 'color-stop(' + val + ', #393f4f)' + ')' + ' -webkit-gradient(linear, left top, right top, ' + 'color-stop(' + val + ', #4eb7cd), ' + 'color-stop(' + val + ', #393f4f)' + ')');
        }

    },

    /*
     * Getters and Setters
     */
    get_animation_slider_value_from_speed: function (speed) {
        var map_controller = this.get_map_controller();
        var map_datetime = map_controller.get_map_datetime();
        var anim_settings = map_datetime.get_animation_settings();
        var diff = anim_settings.animation_rate_base - anim_settings.animation_rate_ceiling;
        var value = 1 - ((speed - anim_settings.animation_rate_ceiling) / diff);
        return value;
    },
    get_animation_speed_from_slider_value: function (slider_value) {
        var map_controller = this.get_map_controller();
        var map_datetime = map_controller.get_map_datetime();
        var anim_settings = map_datetime.get_animation_settings();
        var diff = anim_settings.animation_rate_base - anim_settings.animation_rate_ceiling;
        var speed = (1 - slider_value) * diff + anim_settings.animation_rate_ceiling;
        return Math.round(speed);
    },
    get_map_controller: function () {
        if (!this.map_controller) {
            this.map_controller = this.container.retrieve('viewer');
        }
        return this.map_controller;
    },
    set_map_controller: function (ctrlr) {
        this.map_controller = ctrlr;
    },

    destroy: function () {
        Object.each(this.templates, function (value, key) {
            value.destroy();
        });
        if (this.alert_box) {
            this.alert_box.getElements('.sprite_delete').each(function (delete_button_el) {
                delete_button_el.removeEvent('click', this.bound_methods.on_click_alert_box_close);
            }.bind(this));
            this.alert_box.destroy();
            this.alert_box = null;
        }
        if (this.legend_container) {
            this.legend_container.destroy();
            this.legend_container = null;
        }
        if (this.map_controls) {
            this.map_controls.destroy();
            this.map_controls = null;
        }
        if (this.container) {
            this.container.store('viewer_html', null);
            if (this.container.hasClass('radar')) {
                this.container.removeClass('radar');
            }
            this.container.empty();
            this.unapply_map_listeners();
            this.container = null;
        }


        this.removeEvents();
        this.remove_event_listeners();
        this.$events = [];
        this.templates = null;
        this.map_controller = null;
        this.bound_methods = {};

    }
});